export default __webpack_public_path__ + "static/media/back-arrow.47987299.svg";